import { TAXONOMY_LABELS } from "@/i18n/taxonomyLabels";

/**
 * Translate a marketplace category slug via i18n keys `category.{slug}`.
 * Falls back to API name / slug when no dictionary entry exists.
 */
export function categoryLabel(slug, t, fallback) {
  const s = String(slug || "").trim();
  if (!s) return fallback || "";
  if (typeof t === "function") {
    const key = `category.${s}`;
    const translated = t(key, fallback);
    if (translated && translated !== key) return translated;
  }
  return fallback || s;
}

/**
 * Translate a taxonomy label stored in French (subcategory or group name).
 * @param {string} name - Canonical FR label from API / DB
 * @param {string} lang - fr | en | nl
 * @param {string} [fallback]
 */
export function taxonomyLabel(name, lang = "fr", fallback) {
  const fr = String(name || "").trim();
  if (!fr) return fallback || "";
  if (!lang || lang === "fr") return fr;
  const entry = TAXONOMY_LABELS[fr];
  if (!entry) return fallback || fr;
  return entry[lang] || fallback || fr;
}

/** Alias for subcategory / machine-type chips. */
export function subcategoryLabel(name, lang, fallback) {
  return taxonomyLabel(name, lang, fallback);
}

/** Listing condition labels (canonical FR values stored in DB). */
const CONDITION_LABELS = {
  Neuf: { en: "New", nl: "Nieuw" },
  "Comme neuf": { en: "Like new", nl: "Als nieuw" },
  "Excellent état": { en: "Excellent condition", nl: "Uitstekende staat" },
  "Très bon état": { en: "Very good condition", nl: "Zeer goede staat" },
  "Bon état": { en: "Good condition", nl: "Goede staat" },
  "État correct": { en: "Fair condition", nl: "Redelijke staat" },
  "État moyen": { en: "Average condition", nl: "Gemiddelde staat" },
  "À réparer": { en: "Needs repair", nl: "Te herstellen" },
  "Pour pièces": { en: "For parts", nl: "Voor onderdelen" },
};

export function conditionLabel(name, lang = "fr", fallback) {
  const fr = String(name || "").trim();
  if (!fr) return fallback || "";
  if (!lang || lang === "fr") return fr;
  const entry = CONDITION_LABELS[fr];
  if (!entry) return fallback || fr;
  return entry[lang] || fallback || fr;
}
